const ordinalSuffixes = new Map([
  ['one', 'st'],
  ['two', 'nd'],
  ['few', 'rd'],
  ['other', 'th'],
]);
const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });

/**
 * Formats the trial start date from the current trial day number.
 * Day 1 means today is the first day, day N means the trial started N-1 days ago.
 *
 * @param dayNumber - The current day of the trial (1-based, e.g. 1 = today, 3 = started 2 days ago).
 *   Non-finite, zero, and negative values are clamped to 1.
 * @returns A human-readable date string with an ordinal suffix, e.g. `"July 6th"`.
 */
export const formatTrialStartDate = (dayNumber: number): string => {
  const normalized = Number.isFinite(dayNumber)
    ? Math.max(1, Math.floor(dayNumber))
    : 1;
  const startDate = new Date();

  startDate.setDate(startDate.getDate() - (normalized - 1));

  const month = startDate.toLocaleString('en-US', { month: 'long' });
  const day = startDate.getDate();
  const suffix = ordinalSuffixes.get(ordinalRules.select(day)) ?? 'th';

  return `${month} ${day}${suffix}`;
};
